import { lazy } from 'react';
import withSuspense from '../../../../helpers/withSuspense.jsx';
import DynamicSkeletonGrid from '../../../../skeleton_loaders/common/DynamicSkeletonGrid.jsx';
import InputSkeleton from '../../../../skeleton_loaders/common/InputSkeleton.jsx';

const GaugeWidgetSettings = withSuspense(lazy(() => import('./GaugeWidgetSettings.jsx')), <>
  <DynamicSkeletonGrid margin='0 0 1rem 0' rowSizes={[35]} colSizes={['100%']} />
  <InputSkeleton />
  <hr />
  <DynamicSkeletonGrid margin='0 0 1rem 0' rowSizes={[35]} colSizes={['100%']} />
  <InputSkeleton />
  <DynamicSkeletonGrid margin='2rem 0' gap='2rem' rowSizes={Array(8).fill(35)} colSizes={['100%']} />
</>);

export default GaugeWidgetSettings;